import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { Typography } from "@material-ui/core";
import DataSelect from "../../../../../../../ui/DataSelect";
import WorldSkillDataSelect from "../../../../../../../ui/DataSelect/WorldSkillDataSelect";
import { loadList as loadWorldSkills} from "../../../../../../../Dict/WorldSkill/View/fetch";
import { loadList as loadSkillStates } from "../../../../../../../Dict/PersonSkillState/View/fetch";

import { getPersonSkills, getPersonWorldSkills } from "../../../../store/actions";

const styles = () => ({
  root: {
    maxWidth: 774,
    minWidth: 400,
    marginLeft: 8,
    marginRight: 8,
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    },
    "& .MuiGrid-spacing-xs-4 > .MuiGrid-item": {
      paddingTop: 4,
      paddingBottom: 5
    }
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  }
});

const ProfSkills = ({
  classes,
  disabled,
  onSkillsFormChange,
  loadWorldSkills,
  loadSkillStates,
  worldSkillsList = [],
  personSkillsList = [],
  editableSkills,
  editableWorldSkills,

  getPersonSkills,
  getPersonWorldSkills,
  personSkills,
  personWorldSkills,

  editmode,
  personId
}) => {

  const initialWsData = editableWorldSkills.length > 0 ? editableWorldSkills
    : (personWorldSkills.length > 0 ? personWorldSkills
      : []);

  const initialSkillsData = editableSkills.length > 0 ? editableSkills
    : (personSkills.length > 0 ? personSkills
      : []);

  //const initialData = editableSkills || {skillStates: personSkills, worldSkills: personWorldSkills} || initialInfo;
  const [data, setData] = React.useState({skillStates: initialSkillsData, worldSkills: initialWsData});
  const { skillStates, worldSkills } = data;

  const onChange = (field, value) => {
    const newState = {
      ...data,
      [field]: value
    };
    setData(newState);
    onSkillsFormChange(newState);
  };

  React.useEffect(() => {
    loadWorldSkills();
    loadSkillStates();
  }, []);

  React.useEffect(() => {
    getPersonSkills(personId);
    getPersonWorldSkills(personId);

    console.log(initialSkillsData);
  }, [personId]);

  return(
    <div className={classes.root}>
      <Typography className={classes.heading}>Навыки</Typography>
      <DataSelect
        value={skillStates}
        multiple
        getOptionLabel={option => option.name }
        onChange={value => onChange("skillStates", value)}
        label=""
        dataSource={personSkillsList}
        disableClearable={false}
        disabled={disabled || !editmode}
      />

      <Typography className={classes.heading}>Компетенции WorldSkills</Typography>
      <WorldSkillDataSelect
        value={worldSkills}
        dataSource={worldSkillsList}
        onChange={value => onChange("worldSkills", value)}
        disabled={disabled || !editmode}
        label={""}
      />
    </div>
  )
};

const mapStateToProps = state => ({
  worldSkillsList: state.dictWorldSkillView.list,
  personSkillsList: state.dictPersonSkillStateView.list,
  personSkills: state.persons.skills,
  personWorldSkills: state.persons.worldSkills
});

const mapDispatchToProps = dispatch => ({
  loadWorldSkills: () => dispatch(loadWorldSkills()),
  loadSkillStates: () => dispatch(loadSkillStates()),
  getPersonSkills: (id) => dispatch(getPersonSkills(id)),
  getPersonWorldSkills: (id) => dispatch(getPersonWorldSkills(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ProfSkills));
